import React, { lazy } from "react";
import { Routes, Route } from "react-router-dom";
import { LazyLoader } from "../Components";
import { Complain, QuotationApproval, Suggestion } from "../Pages/PublicPage";

const PublicRootLayout = lazy(() => import("../Pages/PublicPage/layout"));
const SurveyForm = lazy(() => import("../Pages/CustomerSurvey/form/SurveyForm"));
const RecurringClientSurvey = lazy(() =>
  import("../Pages/CustomerSurvey/form/RecurringClientSurvey")
);
const ReviewReport = lazy(() => import("../Pages/ReviewReport"));
const DynamicFormView = lazy(() => import("../Pages/DynamicFormView"));

const PublicRoutes = ({ domain, domainError }) => {
  return (
    <Routes>
      <Route element={<LazyLoader><PublicRootLayout /></LazyLoader>}>
        <Route path="complain" element={<LazyLoader><Complain /></LazyLoader>} />
        <Route path="suggestion" element={<LazyLoader><Suggestion /></LazyLoader>} />
        <Route path="quotation-approval/:id" element={<LazyLoader><QuotationApproval /></LazyLoader>} />
        <Route path="survey" element={<LazyLoader><SurveyForm /></LazyLoader>} />
        <Route path="recurringclientsurvey" element={<LazyLoader><SurveyForm /></LazyLoader>} />
        <Route path="review-report" element={<LazyLoader><ReviewReport /></LazyLoader>} />
        <Route path="form-view/:formId" element={<LazyLoader><DynamicFormView /></LazyLoader>} />
      </Route>
    </Routes>
  );
};

export default PublicRoutes;

